// extracted by mini-css-extract-plugin
var _1 = "_goldInventoryTransaction-module__action-container";
var _2 = "_goldInventoryTransaction-module__container";
var _3 = "_goldInventoryTransaction-module__content-container";
var _4 = "_goldInventoryTransaction-module__filter-container";
var _5 = "_goldInventoryTransaction-module__header";
var _6 = "_goldInventoryTransaction-module__title";
export { _1 as "action-container", _2 as "container", _3 as "content-container", _4 as "filter-container", _5 as "header", _6 as "title" }
